/* TODO: t() */
import { useLocation, useHistory } from 'react-router-dom';

import { RouteDescriptor, Destination } from './types';

import { findInHistory } from '../../support/history';
import { canUser } from '../../support/shared/permissionHelpers';
import { User } from '../../types/shared/User';
import { Account } from '../../types/shared/Account';

export function getPath(route: RouteDescriptor) {
  if (route.type === 'page') {
    return route.path;
  }
  return getFirstPath(route.routes) ?? '/';
}

export function getFirstPath(
  routes: ReadonlyArray<RouteDescriptor>,
): string | undefined {
  let firstRoute = routes[0];
  if (!firstRoute) {
    return;
  }
  if (firstRoute.type === 'page') {
    return firstRoute.path;
  }
  if (firstRoute.type === 'parent') {
    return getFirstPath(firstRoute.routes);
  }
}

export function shouldDisplayRoute(
  user: User | null | undefined,
  account: Account,
  route: RouteDescriptor,
) {
  if (route.omitFromNav || route.disabled) {
    return false;
  }
  let isAdmin = account.system_admin;
  if (route.system_admin && !isAdmin) {
    return false;
  }
  let permissionRequired = route.requiresPermissions;
  let userCan = permissionRequired
    ? isAdmin || canUser(user, permissionRequired)
    : true;
  if (!userCan) {
    return false;
  }
  return true;
}

export function useIsActiveRoute() {
  let location = useLocation();
  let isActiveRoute = (route: RouteDescriptor): boolean => {
    return route.type === 'page'
      ? route.path === location.pathname && !route.alias
      : route.routes.some((route) => isActiveRoute(route));
  };
  return isActiveRoute;
}

export function createUseNavigation<RoutePath extends string>() {
  let useNavigation = () => {
    let history = useHistory();
    return {
      navigate: <T extends RoutePath>(...args: Destination<T>) => {
        let path = args[0];
        let params = args[1] || {};
        history.push(resolve(path, params));
      },
      backTo: <T extends RoutePath>(...args: Destination<T>) => {
        let path = args[0];
        let params = args[1] || {};
        let resolvedPath = resolve(path, params);
        let found = findInHistory(resolvedPath);
        if (found) {
          history.go(found.delta);
        } else {
          history.push(resolvedPath);
        }
      },
    };
  };
  return useNavigation;
}

export function resolve(path: string, params: ObjectOf<unknown>) {
  return path.replace(/:([\w-]+)/g, (match, name) => {
    return params[name] ? String(params[name]) : match;
  });
}
